import * as z from "zod/v4";

// Allowed MIME types for attachments
export const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "text/plain",
  "text/markdown",
] as const;

export const MimeTypeSchema = z
  .enum(ALLOWED_MIME_TYPES)
  .describe("MIME type of the attachment");
export type MimeType = z.infer<typeof MimeTypeSchema>;

// Max file size: 25 MB
export const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
